import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class RemindersForm extends Component {
    static contextType = LangContext;
    state = {
        sections: [ 
            ],
        };

        handleAddForm = (sectionName,disabled) => {
            this.setState(prevState => {
            const section = prevState.sections.find(
                (section) => section.name === sectionName
            );
            section.reminders = [
                ...section.reminders,
                {
                    day: 1,
                    client: 0,
                    provider: 0,
                    hasError:false,
                    disabled:disabled
                },
            ];
            return {
                    sections: [...prevState.sections],
                };
            });
        };

        handleRemoveForm = (sectionName, index) => {
            this.setState(prevState => {
            const section = prevState.sections.find(
                (section) => section.name === sectionName
            );
            section.reminders.splice(index, 1);
            return {
                sections: [...prevState.sections],
            };
            });
        };

        handleInputChange = (e, sectionName, index) => {
            const { name, value, type, checked } = e.target;
            const fieldValue = type === "checkbox" ? checked ? 1 : 0 : parseInt(value);
            this.setState(prevState => {
                const section = prevState.sections.find(
                    (section) => section.name === sectionName
                );
                section.reminders[index][name] = fieldValue;
                return {
                    sections: [...prevState.sections],
                };
            });
        };





        handleSubmit = (e) => {
            e.preventDefault();
            let formValid = true;

            const duplicates = {};
            this.state.sections.forEach((section) => {
                section.reminders.forEach((form,index) => {
                    form.hasError = false;
                    section.reminders.forEach((otherForm, otherFormIndex) => {
                        if (otherForm !== form){
                            if(otherForm.day == form.day){
                                if(otherForm.client == 1 && form.client == 1 && (otherForm.client ==  form.client)){
                                    form.hasError = true;
                                    form.error = ' Ya existe un recordatorio en el mismo dia para solicitante';
                                    formValid = false;
                                }
                                if(otherForm.provider == 1 && form.provider == 1 && (otherForm.provider ==  form.provider)){
                                    if(form.hasError == true && otherForm.client == 1){
                                        form.error = ' Ya existe un recordatorio en el mismo dia para solicitante y invitado';
                                    }else{
                                        form.error = ' Ya existe un recordatorio en el mismo dia para invitado';
                                    }
                                    form.hasError = true;
                                    formValid = false;
                                }
                                if((!form.client && !form.provider)){
                                    form.hasError = true;
                                    form.error = ' Es necesario seleccionar al menos una de las opciones';
                                    formValid = false;
                                }
                            }else{
                                if((!form.client && !form.provider)){
                                    form.hasError = true;
                                    form.error = ' Es necesario seleccionar al menos una de las opciones';
                                    formValid = false;
                                }
                            }
                        }else{
                            if((!form.client && !form.provider)){
                                form.hasError = true;
                                form.error = ' Es necesario seleccionar al menos una de las opciones';
                                formValid = false;
                            }
                        }

                    })

                })
            })
            if (!formValid) {
                this.setState({sections: this.state.sections});
            }
            this.setState({sections: this.state.sections});
            const sections = this.state.sections.reduce(
                (obj, section) => ({ ...obj, [section.name]: section.reminders }),
                {}
            );

            if (!formValid) {
                swal.fire({
                    text: 'Revisa que los recordatorios de cada sección sean válidos',
                    icon: "warning",
                    buttonsStyling: false,
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    },
                    timer: 3000
                });
                return;
            }
            axios.post('/api/reminders',{"sections" : this.state.sections }).then(res=>{
                swal.fire({
                    text: getSuccessMessage(res),
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    },
                    timer: 3000
                }).then(function(result) {
                window.location.href = '/reminders/list';
                });
            })
        }
        getReminders = ()=>{
            const { lang } = this.context;
            let disabledForm = !this.props.permissions.reminders.includes('all') && !this.props.permissions.reminders.includes('edit')
            axios.get("/api/reminders").then(res=>{
                let sections = res.data.map(section=>{ 
                    section.name = lang.get('messages.'+section.name.toLowerCase().replace(" ","_"));
                    section.reminders.map(rem=>{
                        rem.disabled = disabledForm;
                        rem.name ='nada';
                    })
                    return section
                })
                this.setState({sections: sections});
            })
        }
        componentDidMount() {
            this.getReminders();
            const { lang } = this.context;
            
           
        }

    render() {
        const { lang } = this.context; 
        return (
            <>
                <div className="card card-custom gutter-b my-5">
                    <div className="card-body border-0 pt-7">
                    <h3 className="card-title align-items-start flex-column">
                    <span className="card-label font-weight-bolder font-size-h4 text-dark-75 mb-5">{lang.get('messages.expedientes')}</span>
                    </h3>
                        {this.state.sections.slice(0, 2).map((section, index, array) => (
                        <div key={section.name} className={`mt-5 mb-10 ${index === array.length - 1 ? '' : 'section_reminder'}`} >
                            <h2 className="card-label font-weight-bolder font-size-h6 text-dark-65 mb-5">{`${section.name}`}                                                                                    </h2>
                            {section.reminders.map((form, index) => (
                                <form className="row align-items-center mt-5 d-flex mt-4 text-dark-50 font-weight-bold font-size-lg" key={index}>
                                    <div className="col-md-3">
                                        {lang.get('messages.cuando_quieres_notificar')}
                                    </div>
                                    <div className="col-md-3">
                                        <select className="form-control"  id="day"
                                        disabled = {form.disabled}
                                        name="day" value={form.day} onChange={(e) => this.handleInputChange(e, section.name, index)}>
                                            <option value="1">{lang.get('messages.lunes')}</option>
                                            <option value="2">{lang.get('messages.martes')}</option>
                                            <option value="3">{lang.get('messages.miercoles')}</option>
                                            <option value="4">{lang.get('messages.jueves')}</option>
                                            <option value="5">{lang.get('messages.viernes')}</option>
                                            <option value="6">{lang.get('messages.sabado')}</option>
                                            <option value="0">{lang.get('messages.domingo')}</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        {lang.get('messages.a_quien_quieres_notificarle')}
                                    </div>
                                    <div className="col-md-3">
                                    <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="client"
                                                name="client"  disabled = {form.disabled}
                                                checked={form.client}
                                                onChange={(e) =>
                                                this.handleInputChange(e, section.name, index)
                                                }
                                                />
                                                <label className="form-check-label" for="inlineCheckbox1">{lang.get('messages.solicitante')}</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                <input  disabled = {form.disabled}
                                                className="form-check-input"
                                                type="checkbox"
                                                id="provider"
                                                name="provider"
                                                checked={form.provider}
                                                onChange={(e) =>
                                                this.handleInputChange(e, section.name, index)
                                                }
                                                />
                                        <label className="form-check-label" for="inlineCheckbox1">Invitado</label>
                                        <i className="flaticon-delete fw-normal ml-3" onClick={() =>this.handleRemoveForm(section.name, index) }></i>
                                        </div>
                                    </div>
                                    { form.hasError==true &&
                                        <>
                                            <div className="offset-md-6 col-md-6 text-danger">
                                                <i className="flaticon2-information fw-normal ml-3 text-danger" ></i>{ form.error }
                                            </div>
                                        </>
                                    }
                                </form>
                            ))}
                        {  ( this.props.permissions.reminders.includes('all') || this.props.permissions.reminders.includes('create') )
                        &&
                        <span className="text-primary"
                        onClick={() => this.handleAddForm(section.name,false)}
                        >
                        + {lang.get('messages.agregar')}
                        </span>
                        }

                        </div>
                        ))}
                    </div>
                </div>
                <div className="card card-custom gutter-b my-5">
                    <div className="card-body border-0 pt-7">
                    <h3 className="card-title align-items-start flex-column">
                    <span className="card-label font-weight-bolder font-size-h4 text-dark-75 mb-5">{lang.get('messages.documentos')}</span>
                    </h3>
                        {this.state.sections.slice(2).map((section, index, array) => (
                        <div key={section.name}  className={`mt-5 mb-10 ${index === array.length - 1 ? '' : 'section_reminder'}`}>
                            <h2 className="card-label font-weight-bolder font-size-h6 text-dark-65 mb-5">{`${section.name}`}</h2>
                            {section.reminders.map((form, index) => (
                            <form className="row align-items-center mt-5 d-flex mt-4 text-dark-50 font-weight-bold font-size-lg" key={index}>
                                <div className="col-md-3">
                                    {lang.get('messages.cuando_quieres_notificar')}
                                </div>
                                <div className="col-md-3">
                                    <select className="form-control"  disabled = {form.disabled} id="day"  name="day" value={form.day} onChange={(e) => this.handleInputChange(e, section.name, index)}>
                                    <option value="1">{lang.get('messages.lunes')}</option>
                                        <option value="2">{lang.get('messages.martes')}</option>
                                        <option value="3">{lang.get('messages.miercoles')}</option>
                                        <option value="4">{lang.get('messages.jueves')}</option>
                                        <option value="5">{lang.get('messages.viernes')}</option>
                                        <option value="6">{lang.get('messages.sabado')}</option>
                                        <option value="0">{lang.get('messages.domingo')}</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    {lang.get('messages.a_quien_quieres_notificarle')}

                                </div>
                                <div className="col-md-3">
                                <div className="form-check form-check-inline">
                                <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="client"
                                            disabled = {form.disabled}
                                            name="client"
                                            checked={form.client}
                                            onChange={(e) =>
                                            this.handleInputChange(e, section.name, index)
                                            }
                                            />
                                            <label className="form-check-label" for="inlineCheckbox1">{lang.get('messages.solicitante')}</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                            <input
                                            className="form-check-input"
                                            type="checkbox"
                                            disabled = {form.disabled}
                                            id="provider"
                                            name="provider"
                                            checked={form.provider}
                                            onChange={(e) =>
                                            this.handleInputChange(e, section.name, index)
                                            }
                                            />
                                    <label className="form-check-label" for="inlineCheckbox1">{lang.get('messages.invitado')}</label>
                                    <i className="flaticon-delete fw-normal ml-3" onClick={() =>this.handleRemoveForm(section.name, index) }></i>

                                    </div>
                                </div>
                                {form.hasError==true &&
                                    <>
                                        <div className="offset-md-6 col-md-6 text-danger">
                                            <i className="flaticon2-information fw-normal ml-3 text-danger" ></i>
                                            { form.error }
                                        </div>
                                    </>
                                    }
                        </form>
                        ))}
                        {  ( this.props.permissions.reminders.includes('all') || this.props.permissions.reminders.includes('create') )
                        &&
                        <span className="text-primary"
                        onClick={() => this.handleAddForm(section.name,false)}
                        >
                        + {lang.get('messages.agregar')}
                        </span>
                        }
                        </div>
                        ))}
                    </div>
                </div>
                <div className="d-flex justify-content-end gap-1">
                <a  href="/reminders/list" type="submit" className="btn btn-secondary">
                    {lang.get('messages.cancelar')}
                </a>
                <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>
                    {lang.get('messages.guardar')}
                </button>
                </div>

            </>
);
}

}

export default RemindersForm;
if (document.getElementById('RemindersForm')) {
    ReactDOM.render(<RemindersForm />, document.getElementById('RemindersForm'));
}
